<template>
  <div v-if="this.type === 'CN' && this.$route.params.id">
    <div class="header mb-6">
      <vs-button color="dark" type="flat" icon-pack="feather" icon="icon-arrow-left" class="p-0"
        @click="goBack()"></vs-button>
      <div class="w-full justify-right">
        <h2 class="pl-2">{{ editRoute ? $t('labels.edit_user') : $t('labels.add_user') }}</h2>
      </div>
    </div>
    <consultant-details v-if="this.type === 'CN'"></consultant-details>
  </div>
  <div v-else>
    <div class="border_bottom">
      <div class="header mb-6">
        <vs-button color="dark" type="flat" icon-pack="feather" icon="icon-arrow-left" class="p-0"
          @click="goBack()"></vs-button>
        <div class="w-full justify-right">
          <h2 class="pl-2">{{ editRoute ? $t('labels.edit_user') : $t('labels.add_user') }}</h2>
        </div>
      </div>
      <form @submit.prevent="checkValidation()" autocomplete="off">
        <vx-card class="page-bg-color addedit-user">
          <div class="vx-row w-full m-0 mt-4">
            <div class="vx-col w-full mb-4">
              <ul class="centerx flex justify-center">
                <li class="mr-4" v-show="showRadio('A')">
                  <vs-radio v-model="type" vs-value="A" :reduce="type => type.value">{{ $t('labels.admin') }}</vs-radio>
                </li>
                <li class="mr-4" v-show="showRadio('CL')">
                  <vs-radio v-model="type" vs-value="CL" :reduce="type => type.value">{{ $t('labels.client')
                  }}</vs-radio>
                </li>
                <li class="mr-4" v-show="showRadio('CN')">
                  <vs-radio v-model="type" vs-value="CN" :reduce="type => type.value">{{ $t('labels.consultant')
                  }}</vs-radio>
                </li>
              </ul>
            </div>
            <div class="vx-row w-full m-0 mt-4" v-if="this.type !== 'CN'">
              <div class="vx-col sm: w-full md:w-1/2 mb-4 sm: p-0 md:pr-6">
                <label>{{ $t('labels.name') }}</label>
                <vs-input type="text" class="w-full mt-1" name="name" :placeholder="$t('labels.name')"
                  icon-pack="feather" icon="icon-user" v-model="name" icon-no-border v-validate="'required|max:255'" />
                <span class="text-danger text-sm">{{ errors.first('name') }}</span>
              </div>
              <div class="vx-col sm: w-full md:w-1/2 sm: p-0 mb-4" v-show="type == 'A'">
                <label>{{ $t('labels.user_role') }}</label>
                <v-select v-model="role_id" class="mt-1" :options="roles" name="role_validation"
                  :reduce="type => type.id" label="name" v-validate="{ required: type === 'A' }" />
                <span class="text-danger text-sm">{{ errors.first('role_validation') }}</span>
              </div>
              <div class="vx-col sm: w-full md:w-1/2 mb-4 sm: p-0" v-show="type !== 'A'">
                <label>{{ $t('labels.organisation_name') }}</label>
                <v-select class="mt-1" v-validate="{ required: type === 'CL' }" v-model="organisation_id"
                  :options="organisations" :reduce="org => org.id" name="organisation_name" label="name" />
                <span class="text-danger text-sm">{{ errors.first('organisation_name') }}</span>
              </div>
              <div class="vx-col sm: w-full md:w-1/2 mb-4 sm: p-0 md:pr-6">
                <label>{{ $t('labels.email') }}</label>
                <vs-input v-validate="'required|email'" type="email" class="w-full mt-1" name="email"
                  icon-pack="feather" icon="icon-mail" v-model="email" icon-no-border
                  :placeholder="$t('labels.email')" />
                <span class="text-danger text-sm">{{ errors.first('email') }}</span>
              </div>

              <div class="vx-col sm: w-full md:w-1/2 mb-4 sm: p-0 subtype" v-show="type === 'CL'">
                <label>{{ $t('labels.subtype') }}</label>
                <v-select class="mt-1" v-validate="{ required: type === 'CL' }" v-model="subtype" :options="subtypes"
                  :disabled="!editRoute ? false : true" :reduce="subtype => subtype.value" label="label"
                  name="subtype" />
                <span class="text-danger text-sm">{{ errors.first('subtype') }}</span>
              </div>
              <div class="vx-col sm: w-full md:w-1/2 sm: p-0 md:pr-6 mb-4" v-if="showo === true && !editRoute">
                <label>{{ $t('labels.owner') }}</label>
                <v-select class="mt-1" v-validate="'required'" v-model="owner" :options="owners" name="owner"
                  :reduce="subtype => subtype.id" label="name" @input="getManagers()" />
                <span class="text-danger text-sm">{{ errors.first('owner') }}</span>
              </div>

              <div class="vx-col sm: w-full md:w-1/2 sm: p-0 mb-4" v-if="showm === true && !editRoute">
                <label>{{ $t('labels.manager') }}</label>
                <v-select class="mt-1" v-validate="'required'" v-model="manager" :options="managers" name="manager"
                  :reduce="subtype => subtype.id" label="name" @input="getOffice()" />
                <span class="text-danger text-sm">{{ errors.first('manager') }}</span>
              </div>
              <div class="vx-col sm: w-full md:w-1/2 sm: p-0 md:pr-6 mb-6" v-if="showof === true && !editRoute">
                <label>{{ $t('labels.office') }}</label>
                <v-select class="mt-1" v-validate="'required'" v-model="office" :options="offices" name="office"
                  :reduce="subtype => subtype.id" label="name" />
                <span class="text-danger text-sm">{{ errors.first('office') }}</span>
              </div>
            </div>

            <div class="vx-col w-full mb-4" v-else>
              <consultant-add v-if="this.type === 'CN'"></consultant-add>
            </div>
            <div class="vx-col w-full mt-2" v-if="this.type !== 'CN'">
              <div class="flex justify-center">
                <vs-button
                  class="vs-component vs-button md:w-auto md:mr-3 md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn"
                  :disabled="button_loading" id="create-user" button="submit">{{ editRoute ? $t('labels.update_user') :
                    $t('labels.add_user') }}</vs-button>
              </div>
            </div>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";
//import AddEditConsultantDetails from "@/layouts/components/consultant-detail/addedit-consultant-details.vue";
import ConsultantDetails from "@/layouts/components/consultant-detail/consultantDetails.vue";
import ConsultantAdd from "@/layouts/components/consultant-detail/consultant-add.vue";

//import EditProfile from "@/views/edit-profile.vue";

export default {
  data() {
    return {
      organisation_id: null,
      organisations: [],
      usertype: "",
      email: null,
      name: null,
      type: "A",
      subtype: null,
      types: [
        { label: this.$t("labels.admin"), value: "A" },
        { label: "Client", value: "CL" },
        { label: "Consultant", value: "CN" }
      ],
      subtypes: [
        { label: "Owner", value: "OW" },
        { label: "Manager", value: "M" },
        { label: "Office", value: "OF" },
        { label: "Fleet", value: "F" }
      ],
      showo: false,
      showm: false,
      showof: false,
      owner: null,
      manager: null,
      office: null,
      fleet: null,
      owners: [],
      managers: [],
      offices: [],
      fleets: [],
      roles: [],
      role_id: null
    };
  },
  computed: {
    editRoute() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      } else {
        return false;
      }
    }
  },
  components: {
    //AddEditConsultantDetails,
    ConsultantDetails,
    ConsultantAdd
  },
  watch: {
    type(value) {
      this.$validator.reset();
      if (value !== "CL") {
        this.subtype = null;
      }
    },
    subtype(value) {
      if (value == "M") {
        this.getAllOwner();
        this.showo = true;
        this.showm = false;
        this.showof = false;
      } else if (value == "OF") {
        this.getAllOwner();
        this.showo = true;
        this.showm = true;
        this.showof = false;
      } else if (value == "F") {
        this.getAllOwner();
        this.showo = true;
        this.showm = true;
        this.showof = true;
      } else {
        this.owners = [];

        this.showo = false;
        this.showm = false;
        this.showof = false;
      }
    }
  },
  mounted() {
    this.setValidationMessage();
    this.fetchOrganisations();
    this.getRoles();
    if (this.editRoute) {
      this.getUser();
    }
  },
  methods: {
    checkValidation() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.createUpdateUser();
        }
      });
    },
    async createUpdateUser() {
      let input = {
        email: this.email,
        name: this.name,
        organisation_id: this.organisation_id,
        type: this.type,
        sub_type: this.subtype,
        role_id: this.role_id
      };

      // var parent_id = null;
      if (this.type == "CL") {
        if (this.subtype == "M") {
          input.parent_id = this.owner;
        } else if (this.subtype == "OF") {
          input.parent_id = this.manager;
        } else if (this.subtype == "F") {
          input.parent_id = this.office;
        }
      }

      let url = this.editRoute
        ? "/users/update/" + this.editRoute
        : "/users/create";
      let response = await this.getHTTPPostResponse(
        url,
        input,
        "#create-user",
        true
      );
      if (response) {
        this.$store.commit("resetState", null, { module: "userData" });
        this.$router.push({ name: "Users" });
      }
    },
    async getUser() {
      let response = await this.getHTTPGetResponse(
        "/users/get/" + this.editRoute
      );
      if (response) {
        let data = response.data;
        let user = data.user;
        if (!user) return;
        this.email = user.email;
        this.name = user.name;
        this.organisation_id = user.organisation_id;
        this.type = user.type;
        this.subtype = user.sub_type;
        this.role_id = user.role_id;
      }
    },
    async getRoles() {
      var input = {
        only_admin_roles: true
      };
      let response = await this.getHTTPPostResponse("/role", input);
      if (response) {
        let data = response.data;
        let roles = data.roles;
        this.roles = roles;
      }
    },
    async getAllOwner() {
      var input = {
        type: "CL",
        sub_type: "OW"
      };
      let response = await this.getHTTPPostResponse("/users", input);
      if (response) {
        let data = response.data.users;

        this.owners = data;
      }
    },
    async getManagers() {
      let response = await this.getHTTPGetResponse("/users/get/" + this.owner);
      if (response) {
        let user = response.data.user;

        this.managers = user.children;
      }
    },
    async getOffice() {
      let response = await this.getHTTPGetResponse(
        "/users/get/" + this.manager
      );
      if (response) {
        let user = response.data.user;

        this.offices = user.children;
      }
    },
    async fetchOrganisations() {
      try {
        let response = await this.getHTTPPostResponse('/organizations/list');
        this.organisations = response.data.organizations; // Adjust based on API structure
      } catch (error) {
        console.error("Failed to fetch organisations", error);
      }
    },
    showRadio(type) {
      if (this.editRoute) {
        return this.type == type;
      } else {
        return true;
      }
    },
    goBack() {
      history.back();
    }
  }
};
</script>
<style scoped>
button.login-btn {
  background: rgba(var(--vs-primary), 1) !important;
}

.vs-button-primary.vs-button-filled:hover {
  box-shadow: 0 8px 25px -8px rgba(var(--vs-primary), 1);
}
</style>
